export default {
    data() {
        return {
            appName: null,
            theme: null,
            crmDomain: null,
            membersDomain: null,
            youtubeVideo: null,
        };
    },
    methods: {
        initializeTheme() {
            let theme = document.head.querySelector('meta[name="active-theme"]');

            if (theme) {
                this.theme = theme.content;
            }
        },
        initializeDomains() {
            this.crmDomain = window.dcrm;
            this.membersDomain = window.dmembs;
        },
        initializeConfiguration() {
            this.appName = window.appName;
            this.youtubeVideo = window.ytv;
        },
    },
    created() {
        this.initializeConfiguration();

        this.initializeTheme();

        this.initializeDomains();
    },
}